import { render, staticRenderFns } from "./RewardsSummary.vue?vue&type=template&id=382c350c&scoped=true"
import script from "./RewardsSummary.vue?vue&type=script&lang=js"
export * from "./RewardsSummary.vue?vue&type=script&lang=js"
import style0 from "./RewardsSummary.vue?vue&type=style&index=0&id=382c350c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382c350c",
  null
  
)

export default component.exports